import { render, staticRenderFns } from "./contractBlockchainCertificateInfo.vue?vue&type=template&id=6a122238&scoped=true"
import script from "./contractBlockchainCertificateInfo.vue?vue&type=script&lang=js"
export * from "./contractBlockchainCertificateInfo.vue?vue&type=script&lang=js"
import style0 from "./contractBlockchainCertificateInfo.vue?vue&type=style&index=0&id=6a122238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a122238",
  null
  
)

export default component.exports